module.exports = "<label *ngIf=\"showCaption\" [ngClass]=\"position === 1 ? '' : _captionWidth\">{{\r\n  caption\r\n}}</label>\r\n\r\n<div [ngClass]=\"position === 1 ? '' : _fieldWidth\">\r\n    <input style=\"text-align: left;\" #input [disabled]=\"disabled\" type=\"text\" [maxlength]=\"maxlength\" [minlength]=\"minlength\" (blur)=\"blur($event.srcElement.value)\" (focus)=\"focus($event)\" class=\"form-control ixsControl\" [(ngModel)]=\"value\" [placeholder]=\"placeholder\"\r\n        (keyup)=\"Keyup($event.srcElement.value)\" />\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixscurrencytextbox/ixscurrencytextbox.component.html
// module id = 1199
// module chunks = 322